// angular
import { Component } from '@angular/core';

// local
import { ISelfServMeta, AnalyticsService } from '@aa/common';
import { QnaNavigationService } from '../qna-navigation.service';

@Component({
  selector: 'aa-qna-cookie-banner',
  templateUrl: './cookie-banner.component.html'
})
export class QnaCookieBannerComponent {

  public showAcceptedBanner: boolean = false;
  public showRejectedBanner: boolean = false;
  public readonly heading: string;

  constructor(navigation: QnaNavigationService, private readonly analytics: AnalyticsService) {
    this.heading = `Cookies on ${navigation.meta.serviceName}`;
  }

  public acceptCookies(): void {
    this.analytics.setCookiePref('accepted');
    this.showAcceptedBanner = true;
  }

  public rejectCookies(): void {
    this.analytics.setCookiePref('rejected');
    this.showRejectedBanner = true;
  }

  public get showCookieBanner(): boolean {
    return !this.analytics.hasCookiePref;
  }

  public hideConfirmation(): void {
    this.showAcceptedBanner = false;
    this.showRejectedBanner = false;
  }
}
